module.exports = __webpack_public_path__ + "static/media/Group 980.76de6917.svg";